var collapsible_list_pair_rtlignore_default = {
  "container": "rUAxQ",
  "title": "tJEYd",
  "viewerContainer": "W-cM0",
  "titleContainer": "FqqSs",
  "content": "_103uY",
  "expandIcon": "mzWbb",
  "dndIcon": "Uog9U",
  "RTL": "Pw8cd",
  "LTR": "DIh2n",
  "itemContainer": "uyNfv",
  "itemContainerViewer": "xJGZY",
  "mouseDown": "Zu3OO",
  "innerEditor": "f3-ln",
  "item": "EGrQa",
  "floatingAddPluginMenuWrapper": "udiTS"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
